import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { Manager, Target, Popper } from 'react-popper';
import ClickAwayListener from 'material-ui/utils/ClickAwayListener';
import Collapse from 'material-ui/transitions/Collapse';
import { MenuItem, MenuList } from 'material-ui/Menu';
import Portal from 'material-ui/Portal';
import classNames from 'classnames';
import Checkbox from 'material-ui/Checkbox';

const styles = () => ({
  checkboxContainer: {
    padding: '20.5px',
    boxSizing: 'border-box',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  checkbox: {
    width: '20px',
    height: '20px',
  },

  popperClose: {
    pointerEvents: 'none',
  },

  dropdown: {
    margin: 12,
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    boxShadow: '0 4px 8px rgba(0,0,0,.12)',
  },

  menuItem: {
    fontSize: 13,
    borderBottom: '1px solid #D8DBDF',
    '&:hover': {
      backgroundColor: 'rgba(26,101,255,.05)',
    }
  },

});

class SearchResultCheckBox extends React.Component {
  initialState = {
    open: false,
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  /**
   * ヘッダのチェックボックス本体のクリック
   * - チェック済み(中間状態を含む)の場合は全解除する
   * - 未チェックの場合は選択メニューを開閉する
   */
  handleToggle = checked => () => {
    if (checked) {
      this.props.handleSelectAll(false);
    } else {
      this.setState({ open: !this.state.open });
    }
  };

  handleClose = event => {
    if (this.target.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  handleClick = (action) => {
    return () => {
      action();
      this.setState({ open: false });
    }
  }

  /**
   * メニューの「全選択」
   *
   * メニューは未チェック時にしか開かないため、常に全選択として動作させる。
   * ※ 以前は indeterminate / isSelectAll から反転して渡していたが、
   *    「isSelectAll = true かつ実質の選択件数が0以下」という状態では
   *    メニューが開くのに全解除が実行され、何度押してもチェックが付かなくなっていた。
   */
  handleSelectAll = () => {
    this.props.handleSelectAll(true);
  }

  render() {
    const {
      classes,
      isSelectAll,
      selectCount,
      unselectedItems,
      selectedItems,
      totalCount,
      disableSort,
    } = this.props;
    const { open } = this.state;

    let checked, indeterminate;

    if (isSelectAll) {
      checked = selectCount - unselectedItems.count() + selectedItems.count() > 0;
      indeterminate = (totalCount > selectCount - unselectedItems.count() + selectedItems.count());
    } else {
      checked = selectedItems.count() > 0;
      indeterminate = checked && totalCount > selectedItems.count();
    }

    return (
      <div className={classes.checkboxContainer}>
        <Manager>
          <Target>
            <div ref={node => this.target = node}>
              <Checkbox
                aria-owns={open ? 'menu-list-collapse' : null}
                aria-haspopup="true"
                checked={checked}
                onClick={this.handleToggle(checked)}
                color="primary"
                className={classes.checkbox}
                indeterminate={indeterminate}
              />
            </div>
          </Target>
          <Portal>
            <Popper
              placement="bottom-start"
              eventsEnabled={open}
              className={classNames({ [classes.popperClose]: !open })}
              style={{ zIndex: 2 }}
            >
              <ClickAwayListener onClickAway={this.handleClose}>
                <Collapse in={open} id="menu-list-collapse" style={{ transformOrigin: '0 0 0' }}>
                  <div className={classes.dropdown}>
                    <MenuList role="menu" style={{ padding: 0 }}>
                      <MenuItem onClick={this.handleClick(this.handleSelectAll)} key={0} className={classes.menuItem}>全選択</MenuItem>
                      {!disableSort && (
                        <MenuItem onClick={
                          this.handleClick(() => this.props.toggleSelectOptionDialog())
                        }
                          key={1}
                          className={classes.menuItem}
                          style={{ border: 'none' }}
                        >
                          件数を指定して選択
                        </MenuItem>
                      )}
                    </MenuList>
                  </div>
                </Collapse>
              </ClickAwayListener>
            </Popper>
          </Portal>
        </Manager>
      </div>
    );
  }
}

SearchResultCheckBox.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  user: PropTypes.object,
  totalCount: PropTypes.number,
  isSelectAll: PropTypes.bool,
  selectCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectedItems: PropTypes.object,
  unselectedItems: PropTypes.object,
  disableSort: PropTypes.bool,
  handleSelectAll: PropTypes.func.isRequired,
  toggleSelectOptionDialog: PropTypes.func.isRequired,
  togglePromotePlanChangeDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(SearchResultCheckBox);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/parts/SearchResultCheckBox.jsx